import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import {
  DialogActionsDirective,
  DialogComponent,
  DialogContentDirective,
  DialogTitleDirective,
} from '@shared/components/dialog/dialog.component';
import { ImageCropperInterface } from '@shared/interfaces/image-cropper.interface';

export const profileAvatarCropperDialogConfig: MatDialogConfig = {
  width: '95vw',
  maxWidth: '800px',
  maxHeight: '90vh',
  disableClose: false,
};
@Component({
  selector: 'app-profile-avatar-cropper-dialog',
  templateUrl: './profile-avatar-cropper-dialog.component.html',
  styleUrls: ['./profile-avatar-cropper-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButton,
    DialogComponent,
    DialogTitleDirective,
    DialogContentDirective,
    ImageCropperComponent,
    DialogActionsDirective,
    TranslatePipe,
  ],
})
export class ProfileAvatarCropperDialogComponent {
  private mdDialogRef = inject<MatDialogRef<ProfileAvatarCropperDialogComponent>>(MatDialogRef);
  data = inject<ImageCropperInterface>(MAT_DIALOG_DATA);

  readonly cropper = viewChild<ImageCropperComponent>('cropper');
  croppedImageBase64: string | null = null;

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImageBase64 = event.base64 ?? null;
  }

  cropperReady() {
    this.updateCroppedImageFromCropper();
  }

  private updateCroppedImageFromCropper() {
    const cropper = this.cropper();
    const result = cropper?.crop('base64');
    if (result?.base64) {
      this.croppedImageBase64 = result.base64;
    }
  }

  saveCroppedImage() {
    if (!this.croppedImageBase64) {
      return;
    }
    const imageDataForBackend = {
      image: this.croppedImageBase64,
    };

    this.mdDialogRef.close(imageDataForBackend);
  }
}
